<template>
    <jet-form-section>
        <template #title>
            Altere Sua Senha
        </template>

        <template #description>
            Certifique-se que você está usando uma senha longa (mais de 8 caracteres) e segura (com maiúsculas, minusculas, símbolos e números).
                        <div class="md:col-span-6 sm:col-span-12 pl-5">
            </div>
        </template>

        <template #form>
            <div class="col-span-3">
                <jet-label for="current_password" value="Senha atual" />
                <jet-input id="current_password" type="password" class=" w-3/4 form-input rounded-md border border-solid border-black text-gray-700 text-left py-2 px-1" v-model="form.current_password" ref="current_password" autocomplete="current-password" />
                <jet-input-error :message="form.error('current_password')" class="mt-2" />
            </div>
            <div class="col-span-1" />
            <div class="col-span-3 pt-6">
                <jet-label for="password" value="Nova senha" />
                <password default-class=" w-3/4 form-input rounded-md border border-solid border-black text-gray-700 text-left py-2 px-1" :secure-length="8" v-model="form.password" :toggle="true" />
            </div>
            <div class="col-span-3 text-sm pt-6">
                    <jet-label for="form.password" value="Regras para a criação da senha" />
                    <i v-if="validatePassword('length')" class="fas fa-check text-green-500" />
                    <i v-if="!validatePassword('length')" class="fas fa-ban text-red-500" />
                        Deve ter 8 ou mais caracteres<br/>

                    <i v-if="validatePassword('upper')" class="fas fa-check text-green-500" />
                    <i v-if="!validatePassword('upper')" class="fas fa-ban text-red-500" />
                        Deve conter pelo menos uma letra maiúscula<br />

                    <i v-if="validatePassword('lower')" class="fas fa-check text-green-500" />
                    <i v-if="!validatePassword('lower')" class="fas fa-ban text-red-500" />
                        Deve conter pelo menos uma letra minúscula<br />

                    <i v-if="validatePassword('number')" class="fas fa-check text-green-500" />
                    <i v-if="!validatePassword('number')" class="fas fa-ban text-red-500" />
                        Deve conter pelo menos um número<br />

                    <i v-if="validatePassword('symbol')" class="fas fa-check text-green-500" />
                    <i v-if="!validatePassword('symbol')" class="fas fa-ban text-red-500" />
                        Deve conter pelo menos um dos símbolos: !@#$%<br />
            </div>
            <div class="col-span-3">
                <jet-label for="password_confirmation" value="Confirme a nova senha" />
                <jet-input id="password_confirmation" type="password" class=" w-3/4 form-input rounded-md border border-solid border-black text-gray-700 text-left py-2 px-1" v-model="form.password_confirmation" autocomplete="new-password" />
                <jet-input-error :message="form.error('password_confirmation')" class="mt-2" />
            </div>

        </template>

        <template #actions>
            <jet-action-message :on="form.recentlySuccessful" class="mr-3">
                Salvo
            </jet-action-message>

            <jet-button @click.native="save()">
                Salvar
            </jet-button>
        </template>
    </jet-form-section>
</template>

<script>
    import JetActionMessage from './../../Jetstream/ActionMessage'
    import JetButton from './../../Jetstream/Button'
    import JetFormSection from './../../Jetstream/FormSection'
    import JetInput from './../../Jetstream/Input'
    import JetInputError from './../../Jetstream/InputError'
    import JetLabel from './../../Jetstream/Label'
    import AppLayout from './../../Layouts/AppLayout'
    import JetActionSection from './../../Jetstream/ActionSection'
    import JetSectionBorder from './../../Jetstream/SectionBorder'
    import JetDangerButton from './../../Jetstream/DangerButton'
    import JetConfirmationModal from "./../../Jetstream/ConfirmationModal"
    import JetTextarea from "../../Jetstream/Textarea"
    import JetProtectedTextarea from "../../Jetstream/ProtectedTextarea"
    import JetAutoComplete from "../../Jetstream/AutoComplete"
    import JetSecondaryButton from "../../Jetstream/SecondaryButton"
    import JetMaskedInput from "../../Jetstream/MaskedInput"
    import JetFetchDoc from "../../Jetstream/FetchDoc"
    import Flash from "../../Helpers/Flash"
    import moment from 'moment/dist/moment'

    export default {
    props: ['user'],
        data() {
            return {
                form: this.$inertia.form({
                    _method: 'PUT',
                    current_password: null,
                    password: null,
                    password_confirmation: null
                }, {
                    resetOnSuccess: false,
                }),
            }
        },

        methods: {

            validatePassword: function (test) {
            if (!this.form.password) {
                return false;
            }
            switch (test) {
                case 'length':
                    return this.form.password.length >= 8;
                case 'upper':
                    return /(?=[A-Z])/.test(this.form.password);
                case 'lower':
                    return /(?=[a-z])/.test(this.form.password);
                case 'number':
                    return /(?=[0-9])/.test(this.form.password);
                case 'symbol':
                    return /(?=[\$!%&#@])/.test(this.form.password)
                }
            },
            validatePasswordSave(password){
                if (!password) {
                    return false;
                }

                let regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/;
                if(regex.exec(password)){
                    if (this.form.password !== this.form.password_confirmation) {
                        this.$toast.open({
                            message: 'A nova senha é diferente da senha de confirmação.',
                            type: 'error',
                            duration: 5000,
                            position: 'top-right'
                        });
                        return true;
                    }
                    return false;
                }else{
                    this.$toast.open({
                        message: 'Senha invalida, varifique as regras para criação da senha.',
                        type: 'error',
                        duration: 5000,
                        position: 'top-right'
                    });
                    return true;
                }
            },
            save: function () {
                if (!this.form.password || this.validatePasswordSave(this.form.password)) {
                    return false;
                }

                const endpoint = `/access/${this.user.id}`;
                this.form.post(endpoint, {
                    preserveScroll: true,
                    onSuccess: () => {
                        this.form.processing = false
                        if (this.$page.props.activeAccount.digit === '' && this.$page.props.activeAccount.number === '') {
                            this.$toast.open({
                                message: 'Senha alterada com sucesso',
                                type: 'success',
                                duration: 5000,
                                position: 'top-right'
                            });
                        }
                    },
                    onError: () => {
                        this.form.processing = false
                    }
                });
            },
        },
        components: {
        AppLayout,
        Flash,
        JetAutoComplete,
        JetSectionBorder,
        JetActionMessage,
        JetActionSection,
        JetDangerButton,
        JetConfirmationModal,
        JetButton,
        JetFormSection,
        JetInput,
        JetTextarea,
        JetProtectedTextarea,
        JetInputError,
        JetLabel,
        JetSecondaryButton,
        JetMaskedInput,
        JetFetchDoc,
        },
    }
</script>
